import {FETCH_COMPANY_REQUEST, FETCH_COMPANY_SUCCES, FETCH_COMPANY_ERROR} from '../constants/Company'

const initialState = {
  item: {},
  hasErrored: false,
  isLoading: false
}

export default function company(state = initialState, action) {
  switch (action.type) {
      case FETCH_COMPANY_REQUEST:
        return {...state, isLoading: true};
      case FETCH_COMPANY_SUCCES:
        return {...state, item: action.payload, isLoading: false};
      case FETCH_COMPANY_ERROR:
        return {...state, hasErrored: true, isLoading: false};
      default:
          return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/company.js